import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import router from '@/router';
import { store } from '@/store/index';
import { dispatchActivateUser } from '@/store/main/actionsMain';
import { commitAddNotification } from '@/store/main/mutations';
import { ref, watch, onMounted } from 'vue';
import { generalApi } from '@/lib/api/general';
import { VProgressCircular } from 'vuetify/lib';

enum ActivationActionStatus {
  PENDING,
  PROCESSING,
  DONE,
  FAILED,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserActivationPage',
  setup(__props) {

const m = defineMessages({
  registrationComplete: 'アカウント登録完了しました！',
  pleaseLogin: 'お手数ですが、',
  loginPage: 'ログイン画面',
  loginInstruction: 'より、ログインしてください。',
  redirectMessage: '5秒後に自動的にログイン画面に遷移します。',
  tokenError: '必要なトークンがセットされていません。',
  invalidToken:
    '新しいリンクの発行が必要なため、管理者もしくは招待者へお問い合わせください、解消しない場合はサポートにお問い合わせください。',
  activationConfirmation: 'アカウント有効化の確認',
  askActivation: 'アカウントを有効化しますか?',
  activationPageExplanation1: 'このページはアカウント有効化の確認用です',
  activationPageExplanation2: 'まだアカウントは有効化されていません',
  activationActionExplanation1:
    'この操作はユーザー本人の確認を目的としています。',
  activationActionExplanation2: 'ページを開いただけでは有効化されません。',
  activate: '有効化する',
  activationProcessing: 'アカウントを有効化しています',
  activationDone: 'アカウントが有効化されました。ログインしてください',
});

const modalActivateUser = ref<boolean>(false);
const activationActionStatus = ref<ActivationActionStatus>(
  ActivationActionStatus.PENDING
);

watch(
  () => activationActionStatus.value,
  (newStatus) => {
    switch (newStatus) {
      case ActivationActionStatus.DONE:
        commitAddNotification(store, {
          messageKey: m.activationDone,
          color: 'success',
        });
        setTimeout(function () {
          router.push({ name: 'login' });
        }, 5 * 1000);
        break;
      case ActivationActionStatus.PROCESSING:
        commitAddNotification(store, {
          messageKey: m.activationProcessing,
          color: 'info',
        });
        break;
      case ActivationActionStatus.FAILED:
        if (router.currentRoute.query.token as string) {
          commitAddNotification(store, {
            messageKey: m.invalidToken,
            color: 'error',
          });
        } else {
          commitAddNotification(store, {
            messageKey: m.tokenError,
            color: 'error',
          });
        }
        router.push({ name: 'login' });
        break;
      default:
        break;
    }
  }
);

const checkToken = async () => {
  const token = router.currentRoute.query.token as string;
  if (!token) {
    throw new Error('Token is missing');
  }

  try {
    await generalApi.verifyToken(token);
  } catch (e) {
    throw new Error('Invalid token');
  }

  return token;
};

const submit = async (token: string): Promise<void> => {
  await dispatchActivateUser(store, {
    token: token,
  });
};

onMounted(() => {
  modalActivateUser.value = true;
});

const checkAndSubmit = async (): Promise<void> => {
  try {
    activationActionStatus.value = ActivationActionStatus.PROCESSING;
    const token = await checkToken();
    if (token) {
      await submit(token);
    }

    activationActionStatus.value = ActivationActionStatus.DONE;
  } catch (e) {
    console.error(e);
    activationActionStatus.value = ActivationActionStatus.FAILED;
  }
};

return { __sfc: true,m, ActivationActionStatus, modalActivateUser, activationActionStatus, checkToken, submit, checkAndSubmit, VProgressCircular }
}

})